<template>
  <div class="subpage" :class="theme">
    <div class="subpage-hero" :class="arrow ? 'arrow' : ''">
      <div class="subpage-hero-bg">
        <slot name="hero-image">theres in image missing here</slot>
      </div>

      <appear>
        <div class="subpage-hero-overlay" v-scroll="darkenBg"></div>
      </appear>

      <div class="subpage-hero-title">
        <slot name="hero-title"></slot>
      </div>
    </div>

    <div class="animation-page">
      <div class="container">
        <div class="project-desc">
          <slot name="description">
            <p>This is default placeholder Text</p>
          </slot>
        </div>

        <div class="project-skills">
          <slot name="skills">this is where the skills go</slot>
        </div>

        <div class="project-pics">
          <slot name="pics"></slot>
        </div>

        <div class="project-add">
          <slot></slot>
        </div>

        <cards>
          <card v-if="this.name !== 'wordpress'">
            <template v-slot:card-image>
              <img src="../assets/img/card-img-3.jpg" alt="wordpress" />
            </template>
            <template v-slot:card-title>Wordpress</template>
            <template v-slot:card-link>
              <!-- <router-link to="/wordpress">View Project</router-link> -->
              <anim-arrow link="/wordpress">
                <slot name="link"><span>View Project </span></slot>
              </anim-arrow>
            </template>
          </card>

          <card v-if="this.name !== 'drupal'">
            <template v-slot:card-image>
              <!-- <img src="../assets/img/card-img-1.jpg" alt="drupal" /> -->
              <img src="../assets/img/drupal_pattern.jpg" />
            </template>
            <template v-slot:card-title>Drupal</template>
            <template v-slot:card-link>
              <anim-arrow link="/drupal">
                <slot name="link"><span>View Project </span></slot>
              </anim-arrow>
            </template>
          </card>

          <card v-if="this.name !== 'animation'">
            <template v-slot:card-image>
              <img src="../assets/img/card-img-6.jpg" alt="animation" />
            </template>
            <template v-slot:card-title>Animation</template>
            <template v-slot:card-link>
              <anim-arrow link="/animation">
                <slot name="link"><span>View Project </span></slot>
              </anim-arrow>
            </template>
          </card>

          <card v-if="this.name !== 'js'">
            <template v-slot:card-image>
              <img src="../assets/img/card-img-4.jpg" alt="vue / nuxt" />
            </template>
            <template v-slot:card-title>Vue / Nuxt</template>
            <template v-slot:card-link>
              <anim-arrow link="/js">
                <slot name="link"><span>View Project </span></slot>
              </anim-arrow>
            </template>
          </card>

          <card v-if="this.name !== 'about'">
            <template v-slot:card-image>
              <img src="../assets/img/hello-card.jpg" alt="about" />
            </template>
            <template v-slot:card-title>About</template>
            <template v-slot:card-link>
              <anim-arrow link="/about">
                <slot name="link"><span>View Project </span></slot>
              </anim-arrow>
            </template>
          </card>
        </cards>
      </div>
    </div>
    <div class="preloads">
      <img src="../assets/img/hero-img-8.jpg" />
      <img src="../assets/img/hero-img-6.jpg" />
      <img src="../assets/img/drupal_pattern.jpg" />
      <img src="../assets/img/hero-img-4.jpg" />
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import card from "@/components/Card";
import cards from "@/components/Cards";
import appear from "@/components/Appear";
import animArrow from "../components/AnimArrow.vue";

export default {
  name: "subpageLayout",
  props: {
    theme: String,
    name: String,
  },
  components: {
    card,
    cards,
    appear,
    animArrow,
  },

  data() {
    return {
      tl: null,
      arrow: false,
    };
  },
  mounted() {
    this.tl = gsap.timeline({ paused: true });
    this.initTween();
    this.animInArrow();
  },
  methods: {
    initTween() {
      let el = document.querySelector(".subpage-hero-bg img");

      if (this.$route.name === "animation") {
        this.tl.set(el, {
          filter: "blur(0px) brightness(1)",
        });
        this.tl.to(
          el,
          {
            duration: 1,
            filter: "blur(20px) brightness(0.4)",
          },
          "same"
        );
      } else {
        this.tl.set(el, {
          filter: "blur(0px) hue-rotate(0deg) brightness(1)",
        });
        this.tl.to(
          el,
          {
            duration: 1,
            filter: "blur(20px) hue-rotate(100deg) brightness(0.4)",
          },
          "same"
        );
      }
    },
    animInArrow() {
      const self = this;
      setTimeout(() => {
        self.arrowAnimation();
      }, 1500);
    },

    darkenBg() {
      // this translates the scroll from v-scroll directve into timeline progess
      let pr = window.scrollY * 0.002;
      this.tl.progress(pr);
    },
    arrowAnimation() {
      this.arrow = true;
    },
  },
};
</script>

<style lang="scss">
.subpage {
  p,
  li {
    font-size: 1.3rem;
  }
  &.dark {
    .animation-page {
      background-color: rgb(13, 0, 34);
    }
    p {
      margin: 1rem 0;
    }

    p,
    li {
      color: white;
    }
    p,
    li {
      font-weight: 400;
    }

    h2,
    .h2,
    .h3,
    h3 {
      color: white;
    }
  }
  &.light {
    .animation-page {
      background-color: #fff;
    }
    p,
    li {
      color: #311971;
    }
    h2,
    .h2,
    .h3,
    h3 {
      color: #311971;
    }
  }
}
.subpage-hero {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;

  .light & {
    background-image: linear-gradient(45deg, #c8b0f9 50%, #de93d1);
  }
  .dark & {
    background-image: linear-gradient(45deg, #c8b0f9 50%, #de93d1);
  }

  .animation & {
    background-color: black;
    background-image: linear-gradient(45deg, black, #c8b0f9, #de93d1);
  }

  &::before {
    content: "";
    position: absolute;
    background-image: url(../assets/img/arrow-light.svg);
    left: 50%;
    bottom: 0;
    width: 1.3rem;
    height: 4rem;
    margin-left: -1rem;
    justify-content: center;
    align-items: center;
    display: flex;

    background-repeat: no-repeat;
    opacity: 0;
    transition: all 3s ease-in-out;
    z-index: 10;
  }

  &.arrow {
    &::before {
      opacity: 1;
    }
  }

  @include breakpoint(xl) {
    height: 80vh;
  }
}

.subpage-hero-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: overlay;
}

.subpage-hero-bg img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.subpage-hero-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 1;
  display: block;
}

.container {
  //max-width: 900px;
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  padding-left: 12px;
  padding-right: 12px;
  & > div {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  @include breakpoint(md) {
    max-width: 720px;
    padding-left: 0;
    padding-right: 0;
  }
  @include breakpoint(lg) {
    max-width: 960px;
  }
  @include breakpoint(xl) {
    max-width: 1140px;
  }
}
.subpage-hero-title {
  color: #fff;
  font-size: 3rem;
  font-weight: 700;
  position: relative;
  @include breakpoint(sm) {
    font-size: 6rem;
  }
  @include breakpoint(md) {
    font-size: 8rem;
  }
}

.animation-page {
  position: relative;

  & > div {
    padding-top: 1px;
    padding-bottom: 1px;

    &:first-child {
      margin-top: 100vh;

      @include breakpoint(xl) {
        margin-top: 80vh;
      }
    }
  }
}

.mrow {
  display: block;
  @include breakpoint(sm) {
    display: flex;
  }

  &.margin {
    @include breakpoint(sm) {
      margin-left: -10px;
      margin-right: -10px;
    }
    .mcol {
      @include breakpoint(sm) {
        margin: 10px;
      }
    }
  }

  .mcol {
    flex-grow: 1;
    flex-basis: 50%;
  }
}

.project-pics {
  & > div {
    margin: 1rem 0;
  }
}
.project-desc {
  h2 {
    margin-top: 3rem;
  }
}

.preloads {
  display: none;
}
</style>
